<script lang="ts">
    import RewardsIconButton from "@apps/rewards/components/Buttons/RewardsIconButton.svelte";
    import RewardsIcon from "@apps/rewards/components/RewardsIcon.svelte";
    import { isElementDirectionRtl } from "@apps/rewards/utils/isElementDirectionRtl";
    import { fade } from "svelte/transition";

    import CloseIcon from "./icons/CloseIcon.svelte";

    //Props
    export let widgetPosition: string;
    export let onClose: () => void;

    //Variables
    let isDirectionRtl = isElementDirectionRtl();
</script>

<div
    class="gw-rd-popup-widget-container gw-rd-popup-widget-container--{widgetPosition}"
    transition:fade={{ duration: 150, delay: 50 }}
>
    <slot />

    <div
        class="gw-rd-popup-widget-container__close-button"
        class:gw-rd-popup-widget-container__close-button--is-rtl={isDirectionRtl}
    >
        <RewardsIconButton on:click={onClose} ariaLabel="Close">
            <RewardsIcon isBrandingIconColor={false}>
                <CloseIcon />
            </RewardsIcon>
        </RewardsIconButton>
    </div>
</div>

<style lang="postcss">
    @define-mixin spacing $desktopRight, $desktopLeft, $mobileRight, $mobileLeft,
        $class {
        &--$(class) {
            position: fixed;
            top: auto;

            @media (width >= 768px) {
                right: $desktopRight;
                left: $desktopLeft;
                bottom: calc(
                    65px +
                        var(
                            --gw-rd-popup-widget-launcher__desktop_bottom-spacing
                        )
                );
                height: calc(
                    100% - 90px -
                        var(
                            --gw-rd-popup-widget-launcher__desktop_bottom-spacing
                        )
                );
            }

            @media (width < 768px) {
                right: $mobileRight;
                left: $mobileLeft;
                bottom: calc(
                    65px +
                        var(
                            --gw-rd-popup-widget-launcher__mobile_bottom-spacing
                        )
                );
                height: calc(
                    100% - 90px -
                        var(
                            --gw-rd-popup-widget-launcher__mobile_bottom-spacing
                        )
                );
            }
        }
    }

    .gw-rd-popup-widget-container {
        width: 360px;

        max-height: 625px;
        z-index: var(--gw-z-index-drawer);
        color: var(--gw-rd-primary-color);
        background-color: var(--gw-rd-white-color);
        box-shadow: 0px 0px 10px 2px var(--gw-rd-main-shadow);
        border-radius: var(--gw-rd-border-radius-base);
        overflow: hidden;

        @mixin spacing var(--gw-rd-popup-widget-launcher__desktop_side-spacing),
            auto, var(--gw-rd-popup-widget-launcher__mobile_side-spacing), auto,
            BR;
        @mixin spacing auto,
            var(--gw-rd-popup-widget-launcher__desktop_side-spacing), auto,
            var(--gw-rd-popup-widget-launcher__mobile_side-spacing), BL;

        @media (width <= 576px), (height <= 450px) {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100vw;
            height: 100%;
            max-height: 100%;
            border-radius: unset;

            :global(.gw-rd-popup-widget-fixed-header) {
                border-radius: unset;
            }
        }

        &__close-button {
            position: absolute;
            top: 20px;
            right: 16px;
            color: var(--gw-rd-popup-widget-banner__font-color);
            z-index: 3;

            &--is-rtl {
                right: auto;
                left: 16px;
            }
        }
    }
</style>
